import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    relatedToText: {
      borderRadius: 11,
      color: theme.palette.text.subtitle,
      display: 'inline-block',
      marginTop: 10,
      padding: '5px 18px',
      textTransform: 'capitalize',
    },
  };
});

export default useStyles;
